import gql from 'graphql-tag'

export default gql`query ycmdRecordingUrlGet($recording_id: ID, $job_id: ID) {
    ycmdRecordingUrlGet(recording_id: $recording_id, job_id: $job_id)
}`
